import React, { useEffect, useState, useContext } from 'react';
import { CardContent, CardHeader, Container, Expandable, IconsContainer, ContentTextArea, ButtonContent } from './styles'
import PropTypes from 'prop-types';
import Icon from '../../components/Icon';
import { FitinsurAPI } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { TextEditorBox } from '../../components';
import Button, { ButtonContainer } from 'components/Button';
import { Field } from 'formik';

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
};
export default function ClausesAccordion({ setFieldValue, title, clause, isEditable, values, onClauseChange, onBlur, permission, idProduct }) {
  const [expanded, setExpanded] = useState(clause?.idDomain === 637 && idProduct === 48);
  const [expanding, setExpanding] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const [beforeCollapsing, setBeforeCollapsing] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();

  const accordionState = (state) => {
    setExpanding(false);
    setCollapsing(false);
    setBeforeCollapsing(false);
    setExpanded(state);
  };

  const accordionAnimation = (state) => {
    setExpanded(false);
    if (state && !expanded) {
      setExpanding(true);
      setTimeout(() => accordionState(true), 100);
    } else if (!state && expanded) {
      setBeforeCollapsing(true);
      setTimeout(() => {
        setCollapsing(true);
        setTimeout(() => accordionState(false), 100)
      }, 10);
    }
  };

  const handleCancel = () => {
    accordionAnimation(false)
  };

  const handleSave = () => {
    accordionAnimation(false)
  };

  useEffect(() => {
    if (!clause) return;
    setFieldValue(clause.idClause, clause.clauseDescription)
  }, [clause])

  return (
    <Container>
      <CardHeader>
        <IconsContainer>
          <Icon
            className={(!expanded || collapsing) && !expanding ? 'closed' : ''}
            name="arrowup"
            onClick={() => {
              accordionAnimation(!expanded);
              !firstLoad && setFirstLoad(true);
            }
            }
          />
        </IconsContainer>
        <span style={{ fontSize: '13px' }}>
          {title}
        </span>
      </CardHeader>
      <CardContent className={expanded ? 'expanded' : beforeCollapsing ? 'before-collapsing' : (collapsing ? 'collapsing' : (expanding ? 'expanding' : ''))} >
        <Expandable>
          {
            firstLoad && 
              <ContentTextArea>
                <Field
                  key={`${clause.idClause}-field`}
                  disabled={!permission || !isEditable}
                  name={clause.idClause}
                  fieldName={clause.idClause}
                  initialValue={clause.defaultClauseDescription}
                  type="text"
                  onBlur={(value) => {
                    onBlur && onBlur(clause, value)
                  }}
                  preview={true}
                  component={TextEditorBox}
                  value={values && values[clause.idClause]}
                  onChange={(value) => {
                    setFieldValue(clause.idClause, value)
                    onClauseChange && onClauseChange(clause, value)
                  }}
                />
              </ContentTextArea>
          }
        </Expandable>
      </CardContent>
    </Container>
  );
}

ClausesAccordion.propTypes = propTypes;
